// Concrete "how to open this" content for every investment option in Sereno.
// Kept separate from finance.js to stay readable.

export const OPEN_INFO = {
  // ---------- FRANCE ----------
  livret_a: {
    fr: {
      providers: [
        { name: "Boursorama Banque", key: "boursorama", url: "www.boursorama-banque.com", phone: "01 46 09 49 49", online: true, note: "100% en ligne, aucun frais, ouverture en 15 minutes." },
        { name: "Fortuneo", key: "fortuneo", url: "www.fortuneo.fr", phone: "02 22 74 22 22", online: true, note: "En ligne, sans frais, service rapide." },
        { name: "Votre banque habituelle", url: null, phone: null, online: false, note: "Toutes les banques françaises proposent le Livret A. Prenez rendez-vous avec votre conseiller." },
      ],
      docs: ["Carte d'identité (recto ET verso)", "Justificatif de domicile de moins de 3 mois (facture EDF, eau, téléphone)", "RIB de votre compte courant"],
      min_amount: "10 €",
      time_online: "15 minutes",
      time_branch: "30 minutes en agence",
      phrase_to_say: "Bonjour, j'aimerais ouvrir un Livret A. Pouvez-vous m'expliquer les étapes ?",
      reassurance: "Le Livret A est garanti par l'État français. Vous ne pouvez pas perdre votre argent. Vous pouvez retirer quand vous voulez.",
    },
    en: {
      providers: [
        { name: "Boursorama Banque", key: "boursorama", url: "www.boursorama-banque.com", phone: "+33 1 46 09 49 49", online: true, note: "100% online, no fees, opens in 15 minutes." },
        { name: "Fortuneo", key: "fortuneo", url: "www.fortuneo.fr", phone: "+33 2 22 74 22 22", online: true, note: "Online, no fees, fast service." },
        { name: "Your usual bank", url: null, phone: null, online: false, note: "Every French bank offers Livret A. Book an appointment with your advisor." },
      ],
      docs: ["ID card (both sides)", "Proof of address less than 3 months old (electricity, water, phone bill)", "Bank statement from your current account"],
      min_amount: "€10",
      time_online: "15 minutes",
      time_branch: "30 minutes in branch",
      phrase_to_say: "Hello, I'd like to open a Livret A. Can you walk me through the steps?",
      reassurance: "The Livret A is guaranteed by the French State. You cannot lose your money. You can withdraw anytime.",
    },
  },
  assurance_vie: {
    fr: {
      providers: [
        { name: "Boursorama Vie", key: "boursorama_vie", url: "www.boursorama-banque.com", phone: "01 46 09 49 49", online: true, note: "Frais réduits, ouverture en ligne, versements libres." },
        { name: "Linxea Avenir 2", key: "linxea_avenir_2", url: "www.linxea.com", phone: "01 48 87 40 40", online: true, note: "Courtier reconnu, frais bas, service humain." },
        { name: "Votre banque ou assureur", url: null, phone: null, online: false, note: "Toutes les banques proposent une assurance-vie. Attention aux frais parfois élevés." },
      ],
      docs: ["Carte d'identité", "Justificatif de domicile récent", "RIB", "Vos coordonnées de bénéficiaire (personne à qui l'argent ira en cas de décès)"],
      min_amount: "100 €",
      time_online: "20 minutes",
      time_branch: "45 minutes en agence",
      phrase_to_say: "Bonjour, j'aimerais ouvrir une assurance-vie, en fonds euros pour commencer. Pouvez-vous m'expliquer vos frais et vos options ?",
      reassurance: "Sur le fonds euros, votre capital est garanti. Vous pouvez retirer à tout moment. Les intérêts sont peu imposés après 8 ans.",
    },
    en: {
      providers: [
        { name: "Boursorama Vie", key: "boursorama_vie", url: "www.boursorama-banque.com", phone: "+33 1 46 09 49 49", online: true, note: "Low fees, online opening, flexible deposits." },
        { name: "Linxea Avenir 2", key: "linxea_avenir_2", url: "www.linxea.com", phone: "+33 1 48 87 40 40", online: true, note: "Reputable broker, low fees, human service." },
        { name: "Your bank or insurer", url: null, phone: null, online: false, note: "Every bank offers life insurance. Beware of high fees." },
      ],
      docs: ["ID card", "Recent proof of address", "Bank statement", "Beneficiary details (who receives the money on death)"],
      min_amount: "€100",
      time_online: "20 minutes",
      time_branch: "45 minutes in branch",
      phrase_to_say: "Hello, I'd like to open a life insurance, starting with the euro fund. Can you explain your fees and options?",
      reassurance: "On the euro fund, your capital is guaranteed. You can withdraw anytime. Interest is lightly taxed after 8 years.",
    },
  },
  etf_world: {
    fr: {
      providers: [
        { name: "Boursorama (PEA)", key: "boursorama", url: "www.boursorama-banque.com", phone: "01 46 09 49 49", online: true, note: "PEA sans frais d'entrée, ETF Amundi MSCI World disponible." },
        { name: "Trade Republic", url: "www.traderepublic.com", phone: null, online: true, note: "Application mobile simple, 1 € par ordre. Compte-titres." },
        { name: "Fortuneo (PEA)", key: "fortuneo", url: "www.fortuneo.fr", phone: "02 22 74 22 22", online: true, note: "PEA compétitif, sélection d'ETF." },
      ],
      docs: ["Carte d'identité", "Justificatif de domicile récent", "RIB", "Avis d'imposition (numéro fiscal demandé)"],
      min_amount: "20 € (le prix d'une part d'ETF)",
      time_online: "20-30 minutes pour ouvrir le PEA",
      time_branch: "1 heure en agence (déconseillé, plus de frais)",
      phrase_to_say: "Bonjour, j'aimerais ouvrir un PEA pour investir dans un ETF Monde à long terme. Quels sont vos frais et votre sélection d'ETF ?",
      reassurance: "Un ETF Monde peut baisser à court terme, mais sur 10 ans il a toujours progressé. Investissez seulement ce que vous n'avez pas besoin de récupérer dans les 5 prochaines années.",
    },
    en: {
      providers: [
        { name: "Boursorama (PEA)", key: "boursorama", url: "www.boursorama-banque.com", phone: "+33 1 46 09 49 49", online: true, note: "No entry fees on PEA, Amundi MSCI World ETF available." },
        { name: "Trade Republic", url: "www.traderepublic.com", phone: null, online: true, note: "Simple mobile app, €1 per order. Securities account." },
        { name: "Fortuneo (PEA)", key: "fortuneo", url: "www.fortuneo.fr", phone: "+33 2 22 74 22 22", online: true, note: "Competitive PEA, curated ETF selection." },
      ],
      docs: ["ID card", "Recent proof of address", "Bank statement", "Tax notice (fiscal number required)"],
      min_amount: "€20 (one ETF share)",
      time_online: "20-30 minutes to open the PEA",
      time_branch: "1 hour in branch (not recommended, higher fees)",
      phrase_to_say: "Hello, I'd like to open a PEA to invest in a World ETF long-term. What are your fees and ETF selection?",
      reassurance: "A World ETF can drop short-term, but over 10 years it has always risen. Invest only what you won't need in the next 5 years.",
    },
  },

  // ---------- INTERNATIONAL ----------
  high_yield_savings: {
    fr: {
      providers: [
        { name: "Wise Balance", url: "wise.com", phone: null, online: true, note: "Multi-devise, sécurisé, ouverture en ligne rapide." },
        { name: "Revolut Savings", url: "www.revolut.com", phone: null, online: true, note: "Application simple, intérêts quotidiens." },
        { name: "Votre banque locale", url: null, phone: null, online: false, note: "La plupart des banques proposent un compte d'épargne. Comparez les taux." },
      ],
      docs: ["Pièce d'identité", "Justificatif de domicile", "Selfie de vérification (souvent)"],
      min_amount: "1 $ / 1 €",
      time_online: "10 minutes",
      time_branch: "30 minutes",
      phrase_to_say: "Bonjour, je souhaite ouvrir un compte d'épargne. Quel est votre taux et quels sont les frais ?",
      reassurance: "Un compte d'épargne classique est protégé par la garantie des dépôts (souvent jusqu'à 100 000 €). Aucun risque de perte.",
    },
    en: {
      providers: [
        { name: "Wise Balance", url: "wise.com", phone: null, online: true, note: "Multi-currency, secure, quick online opening." },
        { name: "Revolut Savings", url: "www.revolut.com", phone: null, online: true, note: "Simple app, daily interest." },
        { name: "Your local bank", url: null, phone: null, online: false, note: "Most banks offer a savings account. Compare rates." },
      ],
      docs: ["ID", "Proof of address", "Verification selfie (often)"],
      min_amount: "$1 / €1",
      time_online: "10 minutes",
      time_branch: "30 minutes",
      phrase_to_say: "Hello, I'd like to open a savings account. What's your rate and what are the fees?",
      reassurance: "A standard savings account is protected by deposit insurance (often up to €100,000). No risk of loss.",
    },
  },
  balanced_fund: {
    fr: {
      providers: [
        { name: "Nutmeg / Wealthsimple / Yomoni", url: "www.yomoni.fr", phone: null, online: true, note: "Gestion pilotée, vous répondez à un questionnaire et ils investissent pour vous." },
        { name: "Votre banque", url: null, phone: null, online: false, note: "Demandez un fonds équilibré à votre conseiller. Attention aux frais." },
      ],
      docs: ["Pièce d'identité", "Justificatif de domicile", "RIB", "Informations sur vos revenus"],
      min_amount: "1 000 € en général",
      time_online: "30 minutes",
      time_branch: "1 heure",
      phrase_to_say: "Bonjour, j'aimerais investir dans un fonds équilibré (obligations + actions). Quelles options me proposez-vous ?",
      reassurance: "Un fonds équilibré peut fluctuer, mais moins qu'un fonds 100 % actions. Idéal pour un horizon de 5-10 ans.",
    },
    en: {
      providers: [
        { name: "Nutmeg / Wealthsimple / Yomoni", url: "www.yomoni.fr", phone: null, online: true, note: "Managed portfolios: answer a questionnaire, they invest for you." },
        { name: "Your bank", url: null, phone: null, online: false, note: "Ask your advisor for a balanced fund. Watch out for fees." },
      ],
      docs: ["ID", "Proof of address", "Bank statement", "Income information"],
      min_amount: "€1,000 typically",
      time_online: "30 minutes",
      time_branch: "1 hour",
      phrase_to_say: "Hello, I'd like to invest in a balanced fund (bonds + stocks). What options do you offer?",
      reassurance: "A balanced fund can fluctuate, but less than a 100% stock fund. Ideal for a 5-10 year horizon.",
    },
  },

  // ---------- BELGIUM ----------
  be_regulated_savings: {
    fr: {
      providers: [
        { name: "MeDirect", url: "www.medirect.be", phone: "02 518 00 02", online: true, note: "Meilleurs taux du marché belge, 100% en ligne." },
        { name: "Argenta", url: "www.argenta.be", phone: "03 285 51 11", online: false, note: "Banque de proximité belge, bons taux." },
        { name: "BNP Paribas Fortis / ING / KBC", url: null, phone: null, online: false, note: "Les grandes banques belges proposent toutes un compte d'épargne réglementé." },
      ],
      docs: ["Carte d'identité belge (eID)", "Preuve d'adresse récente"],
      min_amount: "1 €",
      time_online: "15 minutes",
      time_branch: "30 minutes",
      phrase_to_say: "Bonjour, j'aimerais ouvrir un compte d'épargne réglementé. Quel est votre taux de base + prime de fidélité ?",
      reassurance: "Le compte d'épargne réglementé belge est protégé par l'État jusqu'à 100 000 €. Intérêts partiellement exonérés d'impôt.",
    },
    en: {
      providers: [
        { name: "MeDirect", url: "www.medirect.be", phone: "+32 2 518 00 02", online: true, note: "Best rates on the Belgian market, 100% online." },
        { name: "Argenta", url: "www.argenta.be", phone: "+32 3 285 51 11", online: false, note: "Local Belgian bank, good rates." },
        { name: "BNP Paribas Fortis / ING / KBC", url: null, phone: null, online: false, note: "Major Belgian banks all offer a regulated savings account." },
      ],
      docs: ["Belgian ID (eID)", "Recent proof of address"],
      min_amount: "€1",
      time_online: "15 minutes",
      time_branch: "30 minutes",
      phrase_to_say: "Hello, I'd like to open a regulated savings account. What are your base rate and loyalty premium?",
      reassurance: "The Belgian regulated savings account is protected by the State up to €100,000. Interest is partly tax-exempt.",
    },
  },
  be_branche21: {
    fr: {
      providers: [
        { name: "AG Insurance", url: "www.aginsurance.be", phone: "02 664 81 11", online: false, note: "Leader belge, produits Branche 21 réputés." },
        { name: "Ethias", url: "www.ethias.be", phone: "04 220 31 11", online: false, note: "Assureur belge historique, contact humain." },
        { name: "Votre banque belge", url: null, phone: null, online: false, note: "La plupart des banques proposent des Branche 21." },
      ],
      docs: ["Carte d'identité", "Preuve d'adresse", "Compte bancaire belge", "Bénéficiaire désigné"],
      min_amount: "500 €",
      time_online: "Rarement disponible en ligne",
      time_branch: "1 heure avec conseiller",
      phrase_to_say: "Bonjour, j'aimerais ouvrir un contrat Branche 21 à capital garanti. Quels sont vos frais d'entrée et de gestion ?",
      reassurance: "La Branche 21 garantit votre capital et un rendement minimum. Idéal pour préparer sa retraite sans risque.",
    },
    en: {
      providers: [
        { name: "AG Insurance", url: "www.aginsurance.be", phone: "+32 2 664 81 11", online: false, note: "Belgian leader, well-known Branch 21 products." },
        { name: "Ethias", url: "www.ethias.be", phone: "+32 4 220 31 11", online: false, note: "Historic Belgian insurer, human contact." },
        { name: "Your Belgian bank", url: null, phone: null, online: false, note: "Most banks offer Branch 21 contracts." },
      ],
      docs: ["ID", "Proof of address", "Belgian bank account", "Designated beneficiary"],
      min_amount: "€500",
      time_online: "Rarely available online",
      time_branch: "1 hour with advisor",
      phrase_to_say: "Hello, I'd like to open a Branch 21 contract with guaranteed capital. What are your entry and management fees?",
      reassurance: "Branch 21 guarantees your capital and a minimum return. Ideal to prepare retirement without risk.",
    },
  },

  // ---------- SWITZERLAND ----------
  ch_savings: {
    fr: {
      providers: [
        { name: "PostFinance", url: "www.postfinance.ch", phone: "0848 888 700", online: true, note: "Réseau très large, ouverture en ligne possible." },
        { name: "Migros Bank", url: "www.migrosbank.ch", phone: "0848 845 400", online: true, note: "Taux compétitifs, sans frais de tenue." },
        { name: "UBS / Raiffeisen / Credit Suisse", url: null, phone: null, online: false, note: "Grandes banques suisses, réseau d'agences dense." },
      ],
      docs: ["Passeport ou carte d'identité", "Permis de séjour (si étranger)", "Justificatif de domicile suisse"],
      min_amount: "CHF 1",
      time_online: "20 minutes",
      time_branch: "45 minutes",
      phrase_to_say: "Bonjour, j'aimerais ouvrir un compte d'épargne. Quels sont vos frais de tenue et votre taux ?",
      reassurance: "Vos dépôts sont protégés jusqu'à CHF 100'000 par banque via esisuisse. Aucun risque.",
    },
    en: {
      providers: [
        { name: "PostFinance", url: "www.postfinance.ch", phone: "+41 848 888 700", online: true, note: "Very wide network, online opening available." },
        { name: "Migros Bank", url: "www.migrosbank.ch", phone: "+41 848 845 400", online: true, note: "Competitive rates, no account fees." },
        { name: "UBS / Raiffeisen / Credit Suisse", url: null, phone: null, online: false, note: "Major Swiss banks with dense branch networks." },
      ],
      docs: ["Passport or ID", "Residence permit (if foreign)", "Swiss proof of address"],
      min_amount: "CHF 1",
      time_online: "20 minutes",
      time_branch: "45 minutes",
      phrase_to_say: "Hello, I'd like to open a savings account. What are your account fees and rate?",
      reassurance: "Your deposits are protected up to CHF 100,000 per bank via esisuisse. No risk.",
    },
  },
  ch_3a: {
    fr: {
      providers: [
        { name: "VIAC", url: "www.viac.ch", phone: null, online: true, note: "Application, frais très bas, gestion en actions possible." },
        { name: "frankly (ZKB)", url: "www.frankly.ch", phone: null, online: true, note: "Application ZKB, frais compétitifs." },
        { name: "Votre banque suisse", url: null, phone: null, online: false, note: "Presque toutes les banques proposent un 3e pilier A." },
      ],
      docs: ["Pièce d'identité", "Preuve de domicile suisse", "Attestation d'employeur ou d'AVS", "IBAN suisse"],
      min_amount: "CHF 1 (versement libre jusqu'à CHF 7'056/an en 2026)",
      time_online: "15 minutes",
      time_branch: "1 heure",
      phrase_to_say: "Bonjour, j'aimerais ouvrir un 3e pilier A. Quelle est ma déduction fiscale possible et quels sont vos frais annuels ?",
      reassurance: "Le 3e pilier A réduit vos impôts chaque année et prépare votre retraite. Argent bloqué jusqu'à la retraite (sauf cas particuliers).",
    },
    en: {
      providers: [
        { name: "VIAC", url: "www.viac.ch", phone: null, online: true, note: "App, very low fees, stock-based management available." },
        { name: "frankly (ZKB)", url: "www.frankly.ch", phone: null, online: true, note: "ZKB app, competitive fees." },
        { name: "Your Swiss bank", url: null, phone: null, online: false, note: "Almost every bank offers a Pillar 3a." },
      ],
      docs: ["ID", "Swiss proof of address", "Employer or AVS certificate", "Swiss IBAN"],
      min_amount: "CHF 1 (deposits up to CHF 7,056/yr in 2026)",
      time_online: "15 minutes",
      time_branch: "1 hour",
      phrase_to_say: "Hello, I'd like to open a Pillar 3a. What tax deduction can I expect and what are your annual fees?",
      reassurance: "Pillar 3a reduces your taxes yearly and builds your retirement. Money locked until retirement (with rare exceptions).",
    },
  },

  // ---------- CANADA ----------
  ca_tfsa_savings: {
    fr: {
      providers: [
        { name: "Tangerine", url: "www.tangerine.ca", phone: "1 888 826-4374", online: true, note: "Banque en ligne canadienne, taux compétitifs, sans frais." },
        { name: "EQ Bank", url: "www.eqbank.ca", phone: "1 844 437 2265", online: true, note: "Excellents taux, application simple." },
        { name: "RBC / Desjardins / TD", url: null, phone: null, online: false, note: "Toutes les grandes banques canadiennes offrent le CELI." },
      ],
      docs: ["Pièce d'identité canadienne", "NAS (Numéro d'assurance sociale)", "Preuve d'adresse"],
      min_amount: "1 $",
      time_online: "15 minutes",
      time_branch: "30 minutes",
      phrase_to_say: "Bonjour, j'aimerais ouvrir un CELI. Quel est votre taux et quelles sont les options de placement ?",
      reassurance: "Le CELI est protégé par la SADC jusqu'à 100 000 $. Les gains sont totalement libres d'impôt.",
    },
    en: {
      providers: [
        { name: "Tangerine", url: "www.tangerine.ca", phone: "1 888 826-4374", online: true, note: "Canadian online bank, competitive rates, no fees." },
        { name: "EQ Bank", url: "www.eqbank.ca", phone: "1 844 437 2265", online: true, note: "Excellent rates, simple app." },
        { name: "RBC / Desjardins / TD", url: null, phone: null, online: false, note: "All major Canadian banks offer the TFSA." },
      ],
      docs: ["Canadian ID", "SIN (Social Insurance Number)", "Proof of address"],
      min_amount: "$1",
      time_online: "15 minutes",
      time_branch: "30 minutes",
      phrase_to_say: "Hello, I'd like to open a TFSA. What's your rate and what investment options do you offer?",
      reassurance: "The TFSA is protected by CDIC up to $100,000. Gains are completely tax-free.",
    },
  },
  ca_rrsp_balanced: {
    fr: {
      providers: [
        { name: "Wealthsimple", url: "www.wealthsimple.com", phone: "1 855 255-9038", online: true, note: "Gestion pilotée, frais bas, application simple." },
        { name: "Questrade", url: "www.questrade.com", phone: "1 888 783-7866", online: true, note: "Courtier canadien, ETF gratuits à l'achat." },
        { name: "Votre banque canadienne", url: null, phone: null, online: false, note: "RBC, Desjardins, TD offrent tous des REER équilibrés." },
      ],
      docs: ["Pièce d'identité", "NAS", "Preuve d'adresse", "Informations sur vos revenus"],
      min_amount: "1 $ (Wealthsimple) — 1 000 $ (banques classiques)",
      time_online: "20 minutes",
      time_branch: "1 heure",
      phrase_to_say: "Bonjour, j'aimerais ouvrir un REER équilibré. Quels sont vos frais et quelle est ma déduction fiscale ?",
      reassurance: "Le REER réduit vos impôts chaque année. L'argent croît à l'abri de l'impôt jusqu'à la retraite.",
    },
    en: {
      providers: [
        { name: "Wealthsimple", url: "www.wealthsimple.com", phone: "1 855 255-9038", online: true, note: "Managed portfolio, low fees, simple app." },
        { name: "Questrade", url: "www.questrade.com", phone: "1 888 783-7866", online: true, note: "Canadian broker, free ETF buys." },
        { name: "Your Canadian bank", url: null, phone: null, online: false, note: "RBC, Desjardins, TD all offer balanced RRSPs." },
      ],
      docs: ["ID", "SIN", "Proof of address", "Income details"],
      min_amount: "$1 (Wealthsimple) — $1,000 (classic banks)",
      time_online: "20 minutes",
      time_branch: "1 hour",
      phrase_to_say: "Hello, I'd like to open a balanced RRSP. What are your fees and what tax deduction can I expect?",
      reassurance: "The RRSP reduces your taxes yearly. Money grows tax-sheltered until retirement.",
    },
  },
};

// ---------- Full 8-screen guided flow: Livret A / Boursorama ----------
export const GUIDED_FLOWS = {
  "livret_a__boursorama": {
    fr: {
      title: "Ouvrir votre Livret A chez Boursorama, pas à pas",
      subtitle: "8 petites étapes, on prend notre temps. Vous pouvez faire une pause quand vous voulez.",      steps: [
        {
          title: "Étape 1 — Allez sur le VRAI site",
          body: "1. Ouvrez votre navigateur (Chrome, Safari, Firefox).\n\n2. Dans la barre en haut, tapez EXACTEMENT cette adresse :",
          highlight: "www.boursorama-banque.com",
          tips: [
            "Ne cliquez pas sur les résultats Google — tapez l'adresse à la main.",
            "Vérifiez qu'un petit cadenas 🔒 apparaît à gauche de l'adresse. C'est le signe que c'est sécurisé.",
          ],
          warning: null,
        },
        {
          title: "Étape 2 — Trouvez le Livret A",
          body: "Sur la page d'accueil :\n\n1. Cherchez le mot « Épargne » dans le menu du haut.\n2. Passez la souris dessus (sans cliquer).\n3. Un petit menu apparaît → cliquez sur « Livret A ».\n\nSur la nouvelle page, cherchez le gros bouton orange « Ouvrir un Livret A » et cliquez.",
          highlight: null,
          tips: [
            "Si vous ne voyez pas « Épargne », cherchez « Placements » — même endroit.",
            "Ne vous laissez pas distraire par les autres offres.",
          ],
          warning: null,
        },
        {
          title: "Étape 3 — Préparez vos 3 papiers",
          body: "Avant de continuer, ayez ces 3 documents à côté de vous :\n\n☐ Votre carte d'identité (recto ET verso)\n☐ Une facture récente (EDF, eau, téléphone — moins de 3 mois)\n☐ Un RIB de votre banque actuelle",
          highlight: null,
          tips: [
            "Astuce : prenez chaque document en photo AVEC VOTRE TÉLÉPHONE maintenant. Vous les enverrez plus tard.",
            "Assurez-vous que tout est bien lisible et pas coupé.",
          ],
          warning: "Sans ces 3 papiers, vous ne pourrez pas finir l'ouverture. Si vous n'avez pas tout, cliquez « Je reviens plus tard » — Sereno se souvient de vous.",
        },
        {
          title: "Étape 4 — Créez votre compte Boursorama",
          body: "Boursorama va vous demander :\n\n• Votre adresse email et un mot de passe\n• Un numéro de téléphone (pour recevoir un code de sécurité par SMS)\n\nUn SMS avec un code à 6 chiffres arrivera. Tapez-le dans la case demandée.",
          highlight: null,
          tips: [
            "Notez votre mot de passe sur un papier tout de suite. On oublie vite.",
            "Utilisez une adresse email que vous consultez souvent.",
          ],
          warning: "Ne partagez JAMAIS ce code SMS avec personne au téléphone. Boursorama ne vous demandera jamais ce code par appel.",
        },
        {
          title: "Étape 5 — Remplissez le formulaire",
          body: "Boursorama va vous poser plusieurs questions. Prenez votre temps, il n'y a pas de piège :\n\n• Nom, prénom, date de naissance\n• Adresse complète\n• Nationalité et pays de naissance\n• Situation professionnelle (retraité, salarié, etc.)\n• Numéro fiscal (sur votre avis d'impôts, en haut à droite)",
          highlight: null,
          tips: [
            "Le numéro fiscal fait 13 chiffres, sur la 1ère page de votre avis d'impôts.",
            "Si vous êtes retraitée, indiquez « Retraité(e) » — c'est parfaitement accepté.",
          ],
          warning: "On vous demande vos revenus ? C'est OBLIGATOIRE (loi anti-blanchiment). Ce n'est pas de la curiosité de la banque.",
        },
        {
          title: "Étape 6 — Envoyez vos documents",
          body: "Boursorama va vous demander de télécharger :\n\n1. Photo de la carte d'identité (recto)\n2. Photo de la carte d'identité (verso)\n3. Photo de votre justificatif de domicile\n4. Photo de votre RIB\n\nCliquez sur chaque bouton « Choisir un fichier » et sélectionnez la bonne photo.",
          highlight: null,
          tips: [
            "Si les photos sont sur votre téléphone, envoyez-les d'abord vers votre ordinateur par email ou WhatsApp.",
            "Vous pouvez aussi tout faire depuis votre smartphone si c'est plus simple.",
          ],
          warning: null,
        },
        {
          title: "Étape 7 — Validez et signez en ligne",
          body: "Boursorama va vous montrer un récapitulatif de votre demande.\n\n1. Relisez tout tranquillement.\n2. Cochez les cases pour accepter les conditions.\n3. Cliquez sur « Signer électroniquement ».\n4. Un dernier code SMS arrivera — tapez-le pour valider.",
          highlight: null,
          tips: [
            "La signature électronique a la même valeur qu'une signature papier. C'est légal et sécurisé.",
            "Prenez une capture d'écran du récapitulatif pour vos archives.",
          ],
          warning: null,
        },
        {
          title: "Étape 8 — Bravo ! Recevez votre confirmation",
          body: "C'est fait ! 🎉\n\nDans les 24 à 48 heures, Boursorama vous enverra :\n\n• Un email de confirmation d'ouverture\n• Vos identifiants pour vous connecter à votre espace client\n• Vos IBAN et RIB pour votre Livret A\n\nUne fois connectée, vous pourrez virer vos premiers euros de votre compte courant vers votre Livret A. Vous pouvez commencer avec 10 € — l'important, c'est de démarrer.",
          highlight: null,
          tips: [
            "Le premier virement peut être fait immédiatement depuis votre compte courant Boursorama, ou depuis votre banque habituelle en utilisant l'IBAN du Livret A.",
            "Programmez un virement automatique de 20 € chaque mois — vous ne pourrez plus reculer.",
          ],
          warning: null,
        },
      ],
    },
    en: {
      title: "Open your Livret A at Boursorama, step by step",
      subtitle: "8 small steps, we take our time. You can pause anytime.",
      steps: [
        {
          title: "Step 1 — Go to the REAL website",
          body: "1. Open your browser (Chrome, Safari, Firefox).\n\n2. In the top bar, type this address EXACTLY:",
          highlight: "www.boursorama-banque.com",
          tips: [
            "Don't click Google results — type the address yourself.",
            "Check for a small lock 🔒 on the left of the address. That means secure.",
          ],
          warning: null,
        },
        {
          title: "Step 2 — Find the Livret A",
          body: "On the home page:\n\n1. Look for 'Épargne' in the top menu.\n2. Hover over it (without clicking).\n3. A small menu appears → click 'Livret A'.\n\nOn the new page, find the big orange 'Ouvrir un Livret A' button and click.",
          highlight: null,
          tips: ["If you don't see 'Épargne', look for 'Placements' — same thing."],
          warning: null,
        },
        {
          title: "Step 3 — Prepare your 3 documents",
          body: "Before continuing, have these 3 documents next to you:\n\n☐ Your ID card (both sides)\n☐ A recent utility bill (electricity, water, phone — less than 3 months)\n☐ A bank statement from your current bank",
          highlight: null,
          tips: [
            "Tip: take photos with your PHONE now. You'll upload them later.",
            "Make sure everything is readable and not cut off.",
          ],
          warning: "Without these 3 documents, you can't finish. If you don't have all of them, click 'Come back later' — Sereno remembers you.",
        },
        {
          title: "Step 4 — Create your Boursorama account",
          body: "Boursorama will ask for:\n\n• Your email and a password\n• A phone number (to receive a security code by SMS)\n\nA 6-digit SMS code will arrive. Type it in the requested field.",
          highlight: null,
          tips: ["Write your password down on paper right away.", "Use an email you check often."],
          warning: "NEVER share the SMS code by phone. Boursorama will never ask for that code over a call.",
        },
        {
          title: "Step 5 — Fill in the form",
          body: "Boursorama will ask several questions. Take your time:\n\n• Name, birth date\n• Full address\n• Nationality and country of birth\n• Employment status (retired, employed…)\n• Tax number (top right of your tax notice)",
          highlight: null,
          tips: ["The tax number has 13 digits, on the first page of your tax notice."],
          warning: "They ask for your income? It's REQUIRED by law (anti-money-laundering). Not curiosity.",
        },
        {
          title: "Step 6 — Send your documents",
          body: "Boursorama will ask you to upload:\n\n1. Photo of ID card (front)\n2. Photo of ID card (back)\n3. Photo of proof of address\n4. Photo of bank statement\n\nClick each 'Choose file' and select the right photo.",
          highlight: null,
          tips: ["You can also do everything from your smartphone if simpler."],
          warning: null,
        },
        {
          title: "Step 7 — Confirm and sign online",
          body: "Boursorama shows a summary.\n\n1. Read carefully.\n2. Tick the checkboxes to accept the terms.\n3. Click 'Sign electronically'.\n4. A final SMS code arrives — enter it.",
          highlight: null,
          tips: ["Electronic signature is legal and secure."],
          warning: null,
        },
        {
          title: "Step 8 — Congrats! Get your confirmation",
          body: "Done! 🎉\n\nWithin 24-48 hours, Boursorama will send:\n\n• A confirmation email\n• Your login credentials\n• Your Livret A IBAN\n\nOnce logged in, transfer your first euros — start with €10.",
          highlight: null,
          tips: ["Set up a €20/month automatic transfer — you won't turn back."],
          warning: null,
        },
      ],
    },
  },
  "assurance_vie__boursorama": {
    fr: {
      title: "Ouvrir votre Assurance-vie chez Boursorama Vie, pas à pas",
      subtitle: "8 étapes tranquilles. Prenez votre temps, faites une pause à tout moment.",      steps: [
        {
          title: "Étape 1 — Allez sur le VRAI site",
          body: "1. Ouvrez votre navigateur.\n2. Tapez EXACTEMENT cette adresse dans la barre en haut :",
          highlight: "www.boursorama-banque.com",
          tips: ["Ne cliquez PAS sur les pubs Google.", "Vérifiez le cadenas 🔒 à gauche de l'adresse."],
          warning: null,
        },
        {
          title: "Étape 2 — Trouvez l'Assurance-vie",
          body: "Sur la page d'accueil :\n\n1. Menu du haut → « Épargne »\n2. Dans le sous-menu → « Assurance-vie »\n3. Cliquez sur le bouton « Ouvrir une assurance-vie » (souvent en orange).",
          highlight: null,
          tips: ["Le produit s'appelle « Boursorama Vie »."],
          warning: null,
        },
        {
          title: "Étape 3 — Préparez vos papiers",
          body: "Ayez à portée de main :\n\n☐ Carte d'identité (recto + verso)\n☐ Justificatif de domicile (< 3 mois)\n☐ RIB de votre compte courant\n☐ Nom / prénom / date de naissance / adresse du (des) bénéficiaire(s) — la ou les personnes qui recevront l'argent en cas de décès",
          highlight: null,
          tips: ["Le bénéficiaire peut être votre conjoint, un enfant, ou une association.", "Vous pourrez le changer à tout moment plus tard."],
          warning: "Sans bénéficiaire désigné, la fiscalité avantageuse ne s'applique pas. Ne sautez pas cette case.",
        },
        {
          title: "Étape 4 — Créez votre profil investisseur",
          body: "Boursorama va vous poser quelques questions pour connaître votre situation :\n\n• Vos revenus\n• Votre patrimoine actuel\n• Votre expérience en placements (« Aucune » est une réponse valable !)\n• Votre horizon (5 ans, 8 ans, 10 ans…)\n• Votre tolérance au risque",
          highlight: null,
          tips: ["Répondez honnêtement. Ces questions PROTÈGENT l'épargnant, elles ne sont pas là pour vous piéger."],
          warning: "Si Boursorama vous propose des unités de compte à risque et que vous voulez commencer prudemment, choisissez uniquement le « fonds euros » (capital garanti).",
        },
        {
          title: "Étape 5 — Choisissez votre allocation",
          body: "Boursorama vous demande comment répartir votre argent :\n\n• 100 % fonds euros → capital totalement garanti, rendement modeste (parfait pour débuter)\n• Une part en unités de compte → potentiellement plus, mais risque de perte\n\nPour un premier contrat, restez à 100 % fonds euros. Vous pourrez ajuster plus tard.",
          highlight: null,
          tips: ["Vous pouvez toujours changer la répartition dans quelques mois quand vous serez plus à l'aise."],
          warning: null,
        },
        {
          title: "Étape 6 — Envoyez vos documents",
          body: "Téléchargez :\n\n1. Photo de la carte d'identité (recto)\n2. Photo de la carte d'identité (verso)\n3. Photo du justificatif de domicile\n4. Photo du RIB\n\nCliquez « Choisir un fichier » à chaque étape.",
          highlight: null,
          tips: ["Photos nettes, prises sur fond clair, sans reflets."],
          warning: null,
        },
        {
          title: "Étape 7 — Versement initial et signature",
          body: "Boursorama demande un versement minimum (souvent 300 €).\n\n1. Indiquez le montant que vous voulez placer.\n2. L'argent partira de votre compte courant vers votre assurance-vie.\n3. Relisez le récapitulatif tranquillement.\n4. Cochez les cases d'acceptation.\n5. Signez électroniquement (un SMS avec un code arrive).",
          highlight: null,
          tips: ["Si 300 € vous semble beaucoup, souvenez-vous : c'est votre argent, il n'est PAS bloqué. Vous pouvez retirer quand vous voulez."],
          warning: "NE PARTAGEZ JAMAIS le code SMS au téléphone. Boursorama ne demandera jamais ce code par appel.",
        },
        {
          title: "Étape 8 — Bravo, votre contrat est ouvert 🎉",
          body: "Sous 24-48 heures, vous recevrez :\n\n• L'email de confirmation d'ouverture\n• Vos identifiants pour l'espace client\n• Le numéro de votre contrat d'assurance-vie\n\nEt tous les mois, vous verrez votre épargne grandir doucement.",
          highlight: null,
          tips: ["Programmez un virement mensuel automatique de 50 à 100 € — c'est le geste qui fait toute la différence sur 10 ans.", "Notez la date d'ouverture : après 8 ans, vos intérêts sont peu imposés (avantage fiscal)."],
          warning: null,
        },
      ],
    },
    en: {
      title: "Open your Life Insurance at Boursorama Vie, step by step",
      subtitle: "8 gentle steps. Take your time — pause anytime.",
      steps: [
        { title: "Step 1 — Go to the REAL site", body: "1. Open your browser.\n2. Type EXACTLY:", highlight: "www.boursorama-banque.com", tips: ["Never click Google ads.", "Check for the 🔒 lock on the left of the URL."], warning: null },
        { title: "Step 2 — Find the Life Insurance", body: "1. Top menu → 'Épargne'\n2. Sub-menu → 'Assurance-vie'\n3. Click 'Ouvrir une assurance-vie' (orange button).", highlight: null, tips: ["The product is called 'Boursorama Vie'."], warning: null },
        { title: "Step 3 — Prepare documents", body: "Have ready:\n\n☐ ID card (both sides)\n☐ Proof of address (< 3 months)\n☐ Bank statement\n☐ Beneficiary details (who receives the money on death)", highlight: null, tips: ["The beneficiary can be your spouse, a child, or a charity.", "You can change it anytime."], warning: "No beneficiary = no tax benefit. Don't skip this." },
        { title: "Step 4 — Investor profile", body: "You'll answer:\n\n• Your income\n• Your assets\n• Your investment experience ('None' is a valid answer!)\n• Your horizon (5-10+ years)\n• Your risk tolerance", highlight: null, tips: ["Answer honestly — this PROTECTS you."], warning: "If offered risky unit-linked funds and you want to be careful, pick only the 'euro fund' (guaranteed capital)." },
        { title: "Step 5 — Allocation", body: "100% euro fund → safe, modest return, perfect to start.\nSome in unit-linked → possibly more, but risk of loss.\n\nFirst contract: stay 100% euro fund.", highlight: null, tips: ["You can always reallocate later."], warning: null },
        { title: "Step 6 — Upload documents", body: "Upload 4 photos: ID recto, ID verso, proof of address, bank statement.", highlight: null, tips: ["Clear photos, plain background."], warning: null },
        { title: "Step 7 — First deposit + signature", body: "Minimum deposit is often €300. Enter amount, review, tick acceptance, sign electronically (SMS code).", highlight: null, tips: ["Your money is NOT locked — you can withdraw anytime."], warning: "NEVER share the SMS code by phone." },
        { title: "Step 8 — All done 🎉", body: "Within 24-48h you'll get confirmation email + client credentials + contract number.", highlight: null, tips: ["Set up €50-100 automatic monthly transfer — the game-changer over 10 years.", "Note the opening date: after 8 years, tax on interest is very light."], warning: null },
      ],
    },
  },
  // ---- FORTUNEO ----
  "livret_a__fortuneo": {
    fr: {
      title: "Ouvrir votre Livret A chez Fortuneo, pas à pas",
      subtitle: "7 étapes. Fortuneo est une banque en ligne française, sans frais.",
      steps: [
        { title: "Étape 1 — Le VRAI site Fortuneo", body: "Ouvrez votre navigateur et tapez cette adresse EXACTE dans la barre en haut :", highlight: "www.fortuneo.fr", tips: ["Cadenas 🔒 obligatoire à gauche.", "Ne cliquez pas sur les résultats Google — ce sont souvent des pubs."], warning: null },
        { title: "Étape 2 — Trouver le Livret A", body: "1. Menu du haut → « Épargne »\n2. → « Livret A »\n3. Cliquez sur le bouton d'ouverture.", highlight: null, tips: ["Fortuneo propose aussi le Livret+ (compte d'épargne classique) — restez sur Livret A pour la garantie d'État."], warning: null },
        { title: "Étape 3 — Préparer les papiers", body: "☐ Carte d'identité (recto + verso)\n☐ Justificatif de domicile (< 3 mois)\n☐ RIB de votre compte courant", highlight: null, tips: ["Prenez les photos avec votre téléphone maintenant."], warning: null },
        { title: "Étape 4 — Créer le compte", body: "Fortuneo demande :\n\n• Email + mot de passe\n• Téléphone (SMS de sécurité)\n• Nom, adresse, date de naissance\n• Situation professionnelle et fiscale", highlight: null, tips: ["Notez votre mot de passe sur un papier.", "« Retraité(e) » est une réponse parfaitement valable."], warning: "Ne partagez JAMAIS le code SMS par téléphone." },
        { title: "Étape 5 — Envoyer les documents", body: "Téléchargez vos 4 photos (identité recto, identité verso, justificatif, RIB) via les boutons prévus.", highlight: null, tips: ["Photos nettes, non coupées, sans reflet."], warning: null },
        { title: "Étape 6 — Signature électronique", body: "1. Relisez le récapitulatif.\n2. Cochez les cases d'acceptation.\n3. Signez électroniquement (code SMS).", highlight: null, tips: ["La signature électronique a la même valeur qu'une signature papier."], warning: null },
        { title: "Étape 7 — Confirmation 🎉", body: "Sous 24-48 h, vous recevrez :\n\n• Email de confirmation\n• Identifiants espace client\n• IBAN du Livret A\n\nVous pouvez faire votre premier virement de 10 €.", highlight: null, tips: ["Programmez un virement automatique mensuel de 20-50 €."], warning: null },
      ],
    },
    en: {
      title: "Open your Livret A at Fortuneo, step by step",
      subtitle: "7 steps. Fortuneo is a French online bank with no fees.",
      steps: [
        { title: "Step 1 — The REAL Fortuneo site", body: "Open your browser and type EXACTLY:", highlight: "www.fortuneo.fr", tips: ["🔒 lock required.", "Never click Google ad results."], warning: null },
        { title: "Step 2 — Find the Livret A", body: "1. Top menu → 'Épargne'\n2. → 'Livret A'\n3. Click the opening button.", highlight: null, tips: ["Fortuneo also offers Livret+ (classic savings) — stick to Livret A for state guarantee."], warning: null },
        { title: "Step 3 — Prepare documents", body: "☐ ID card (both sides)\n☐ Proof of address (< 3 months)\n☐ Bank statement", highlight: null, tips: ["Take photos with your phone now."], warning: null },
        { title: "Step 4 — Create your account", body: "Fortuneo asks for:\n\n• Email + password\n• Phone (security SMS)\n• Name, address, birth date\n• Employment + tax status", highlight: null, tips: ["Write your password down.", "'Retired' is a perfectly valid answer."], warning: "NEVER share the SMS code by phone." },
        { title: "Step 5 — Upload documents", body: "Upload the 4 photos.", highlight: null, tips: ["Clear photos, plain background."], warning: null },
        { title: "Step 6 — Electronic signature", body: "Review, tick acceptance boxes, sign with SMS code.", highlight: null, tips: ["Electronic signature is legally binding."], warning: null },
        { title: "Step 7 — Confirmation 🎉", body: "Within 24-48h you'll get: confirmation email, credentials, Livret A IBAN.", highlight: null, tips: ["Set a €20-50 monthly auto-transfer."], warning: null },
      ],
    },
  },
  // ---- LINXEA ----
  "assurance_vie__linxea": {
    fr: {
      title: "Ouvrir votre Assurance-vie chez Linxea Avenir 2, pas à pas",
      subtitle: "7 étapes. Linxea est un courtier indépendant reconnu, avec des frais bas.",
      steps: [
        { title: "Étape 1 — Le site officiel Linxea", body: "Ouvrez votre navigateur et tapez :", highlight: "www.linxea.com", tips: ["Vérifiez le 🔒 à gauche.", "Linxea existe depuis 2001, c'est un vrai courtier français."], warning: null },
        { title: "Étape 2 — Choisir Linxea Avenir 2", body: "1. Menu → « Assurance-vie »\n2. → Choisissez « Linxea Avenir 2 » (le contrat historique, très compétitif)\n3. Cliquez « Souscrire ».", highlight: null, tips: ["Ne vous laissez pas tenter par d'autres contrats plus complexes pour un premier achat."], warning: null },
        { title: "Étape 3 — Papiers à préparer", body: "☐ Carte d'identité (recto + verso)\n☐ Justificatif de domicile (< 3 mois)\n☐ RIB\n☐ Nom / adresse / date de naissance du (des) bénéficiaire(s)", highlight: null, tips: ["Le bénéficiaire peut être votre conjoint(e), un enfant, ou une association.", "Vous pourrez le changer à tout moment."], warning: "Sans bénéficiaire, la fiscalité avantageuse ne s'applique pas." },
        { title: "Étape 4 — Profil investisseur", body: "Linxea demande votre situation :\n\n• Revenus, patrimoine\n• Expérience en placements (« Aucune » est valide)\n• Horizon (choisissez 8-10 ans pour maximiser l'avantage fiscal)\n• Tolérance au risque", highlight: null, tips: ["Répondez honnêtement — c'est pour VOUS protéger."], warning: null },
        { title: "Étape 5 — Choisir l'allocation", body: "Pour un premier contrat : **100 % fonds euros**.\n\nCapital garanti, rendement stable (2-2,5 %/an récemment), aucun risque de perte.\n\nVous pourrez toujours ajuster plus tard quand vous serez à l'aise.", highlight: null, tips: ["Le fonds euros de Linxea Avenir 2 est bien noté depuis des années."], warning: null },
        { title: "Étape 6 — Documents + signature", body: "Téléchargez les photos, versez le minimum (souvent 100 €), signez électroniquement avec code SMS.", highlight: null, tips: ["Votre argent n'est PAS bloqué — vous pouvez retirer à tout moment."], warning: "NE PARTAGEZ JAMAIS le code SMS par téléphone." },
        { title: "Étape 7 — Bravo, ouvert 🎉", body: "Sous quelques jours ouvrés vous recevrez confirmation + numéro de contrat + accès à votre espace client. Programmez un versement mensuel de 50 € pour construire l'habitude.", highlight: null, tips: ["Notez la date d'ouverture : après 8 ans, avantage fiscal important."], warning: null },
      ],
    },
    en: {
      title: "Open your Life Insurance at Linxea Avenir 2, step by step",
      subtitle: "7 steps. Linxea is a respected independent French broker with low fees.",
      steps: [
        { title: "Step 1 — Official Linxea site", body: "Type exactly:", highlight: "www.linxea.com", tips: ["Check the 🔒 lock.", "Linxea has existed since 2001 — a real French broker."], warning: null },
        { title: "Step 2 — Choose Linxea Avenir 2", body: "Menu → 'Assurance-vie' → 'Linxea Avenir 2' → Subscribe.", highlight: null, tips: ["Don't be tempted by more complex contracts for a first buy."], warning: null },
        { title: "Step 3 — Documents", body: "ID (both sides), proof of address, bank statement, beneficiary details.", highlight: null, tips: ["Beneficiary can be spouse, child, or charity.", "You can change anytime."], warning: "No beneficiary = no tax benefit." },
        { title: "Step 4 — Investor profile", body: "Answer about income, assets, experience ('None' OK), horizon (8-10 years for tax benefit), risk tolerance.", highlight: null, tips: ["Be honest — it PROTECTS you."], warning: null },
        { title: "Step 5 — Allocation", body: "First contract: 100% euro fund. Guaranteed capital, stable return (2-2.5%/yr recently).", highlight: null, tips: ["You can rebalance later."], warning: null },
        { title: "Step 6 — Documents + signature", body: "Upload photos, deposit €100 minimum, sign with SMS code.", highlight: null, tips: ["Money is NOT locked."], warning: "NEVER share the SMS code by phone." },
        { title: "Step 7 — All set 🎉", body: "Confirmation + contract number in a few business days. Set €50/mo auto-transfer.", highlight: null, tips: ["After 8 years: major tax benefit."], warning: null },
      ],
    },
  },
  // ---- BANQUE DE QUARTIER (in-person, generic) ----
  "generic__local_bank": {
    fr: {
      title: "Ouvrir dans votre banque du quartier, pas à pas",
      subtitle: "5 étapes pour votre rendez-vous en face à face.",
      steps: [
        { title: "Étape 1 — Prendre rendez-vous", body: "Appelez votre banque et dites simplement :", highlight: "« Bonjour, j'aimerais prendre rendez-vous avec un conseiller pour ouvrir un produit d'épargne. »", tips: ["Prenez un rendez-vous plutôt que d'y aller sans prévenir — le conseiller aura du temps pour vous.", "Précisez au téléphone le produit souhaité (ex : Livret A, Assurance-vie) pour qu'il prépare le dossier."], warning: null },
        { title: "Étape 2 — Préparer vos papiers", body: "Le jour du rendez-vous, apportez :\n\n☐ Carte d'identité\n☐ Justificatif de domicile récent\n☐ Dernier avis d'imposition\n☐ RIB de votre compte courant\n☐ (Pour assurance-vie) Nom du/des bénéficiaire(s)", highlight: null, tips: ["Rangez tout dans une pochette pour ne pas être stressée sur place."], warning: null },
        { title: "Étape 3 — Poser LES 4 questions", body: "Une fois installée face au conseiller, dites d'entrée :\n\n« Avant de signer, je voudrais comprendre 4 choses :\n\n1. Quels sont TOUS les frais (entrée, gestion, sortie) ?\n2. Est-ce que mon argent est bloqué ? Combien de temps ?\n3. Est-ce que le capital est garanti ou puis-je perdre de l'argent ?\n4. Quel est le rendement réel de l'année dernière ? »", highlight: null, tips: ["Notez les réponses sur un papier.", "Un conseiller honnête répondra clairement. S'il évite ou embrouille, méfiance."], warning: "Si on vous met la pression pour signer TOUT DE SUITE, refusez poliment. Dites : « Je veux prendre 24 h pour réfléchir. »" },
        { title: "Étape 4 — Ce qu'il faut EMPORTER", body: "Ne partez JAMAIS de l'agence sans :\n\n☐ Une copie du contrat signé\n☐ Un document résumant les frais\n☐ Le numéro de contrat\n☐ Le nom + numéro direct de votre conseiller", highlight: null, tips: ["Si le conseiller vous dit « je vous les enverrai par courrier », insistez pour repartir avec au moins la copie du contrat."], warning: null },
        { title: "Étape 5 — Chez vous, le lendemain", body: "Une fois rentrée :\n\n• Rangez le contrat dans un classeur\n• Notez la date d'ouverture, le numéro, le nom du conseiller\n• Programmez un rappel dans votre agenda dans 3 mois pour vérifier que tout va bien\n• Enregistrez le numéro du conseiller sur votre téléphone", highlight: null, tips: ["Le vrai travail commence maintenant : verser régulièrement, ne serait-ce qu'un petit montant."], warning: null },
      ],
    },
    en: {
      title: "Open at your neighbourhood bank, step by step",
      subtitle: "5 steps for your face-to-face appointment.",
      steps: [
        { title: "Step 1 — Book an appointment", body: "Call your bank and say simply:", highlight: "\"Hello, I'd like to book an appointment with an advisor to open a savings product.\"", tips: ["Book — don't walk in — so the advisor has time.", "Say which product on the phone so they prepare the file."], warning: null },
        { title: "Step 2 — Prepare your documents", body: "On the day, bring:\n\n☐ ID\n☐ Recent proof of address\n☐ Latest tax notice\n☐ Bank statement\n☐ (For life insurance) Beneficiary name(s)", highlight: null, tips: ["Put it all in a folder to reduce stress on the spot."], warning: null },
        { title: "Step 3 — Ask THE 4 questions", body: "Once seated, say straight away:\n\n\"Before I sign, I want to understand 4 things:\n\n1. What are ALL the fees (entry, management, exit)?\n2. Is my money locked? For how long?\n3. Is capital guaranteed or can I lose money?\n4. What was last year's actual return?\"", highlight: null, tips: ["Write down the answers.", "An honest advisor answers clearly. Evasion = distrust."], warning: "If pressured to sign IMMEDIATELY, politely refuse: 'I want 24h to think.'" },
        { title: "Step 4 — What to take home", body: "NEVER leave the branch without:\n\n☐ Signed contract copy\n☐ Fee summary document\n☐ Contract number\n☐ Advisor name + direct number", highlight: null, tips: ["If they say 'I'll mail it', insist on at least the contract copy."], warning: null },
        { title: "Step 5 — At home, the next day", body: "File the contract. Note opening date, number, advisor. Set a 3-month reminder. Save the advisor's number.", highlight: null, tips: ["Real work starts now: regular deposits, even small ones."], warning: null },
      ],
    },
  },
};

// Map an option ID + provider name to a guided flow if available.
export function findGuidedFlow(optionId, providerName = "") {
  const p = providerName || "";
  if (optionId === "livret_a" && /boursorama/i.test(p)) {
    return GUIDED_FLOWS["livret_a__boursorama"];
  }
  if (optionId === "livret_a" && /fortuneo/i.test(p)) {
    return GUIDED_FLOWS["livret_a__fortuneo"];
  }
  if (optionId === "assurance_vie" && /boursorama/i.test(p)) {
    return GUIDED_FLOWS["assurance_vie__boursorama"];
  }
  if (optionId === "assurance_vie" && /linxea/i.test(p)) {
    return GUIDED_FLOWS["assurance_vie__linxea"];
  }
  return null;
}

// Generic "local bank" flow — always available, in-person, country-agnostic.
export function getLocalBankFlow() {
  return GUIDED_FLOWS["generic__local_bank"];
}
